import { render, staticRenderFns } from "./VideoBackground.vue?vue&type=template&id=63e0aa71&scoped=true&"
import script from "./VideoBackground.vue?vue&type=script&lang=js&"
export * from "./VideoBackground.vue?vue&type=script&lang=js&"
import style0 from "./VideoBackground.vue?vue&type=style&index=0&id=63e0aa71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e0aa71",
  null
  
)

export default component.exports